/**
* 上下游管理 渠道管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>上下游管理</el-breadcrumb-item>
            <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="渠道">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channel_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)"  @change="handleChange1" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channeler_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)"  @change="handleChange2" placeholder="渠道人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道公司">
                <el-input size="small" v-model="formInline.channel_company" placeholder="输入渠道公司"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search"
                    v-auth="'channelinfo.list'">搜索
                </el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
                    v-auth="'channelinfo.addorupdate'">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_id" label="渠道ID" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_name" label="渠道名称" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channeler_id" label="渠道人员ID" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channeler_name" label="渠道人员" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_company" label="渠道公司" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="remark" label="备注" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="update_time" label="修改时间" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间" max-width="120">
                </el-table-column>
                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'channelinfo.addorupdate'">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog()'>
            <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
                <el-form-item label="渠道ID" prop="channel_id" v-if="editForm.channel_id">
                    <el-input size="small" v-model="editForm.channel_id" auto-complete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="渠道名称" prop="channel_name">
                    <el-input size="small" v-model="editForm.channel_name" auto-complete="off" placeholder="请输入渠道名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="渠道人员" prop="channeler_id">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.channeler_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,3)" placeholder="渠道人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
                </el-form-item>
                <el-form-item label="渠道公司" prop="channel_company">
                    <el-input size="small" v-model="editForm.channel_company" auto-complete="off" placeholder="请输入渠道公司">
                    </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入备注">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let change = [];
    import {
        channelList,
        channelListTotal,
        channelInfo,
        channelSave
    } from '../../api/basisMG'
    import { userList } from '../../api/userMG';
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加渠道',
                isShowroleId: 'false',
                editForm: {
                    channel_id: '',
                    channel_name: '',
                    channeler_id: '',
                    channeler_name: '',
                    channel_company: '',
                    remark: '',
                },
                // rules 表单验证
                rules: {
                    channel_name: [
                        { required: true, message: '请输入渠道名称', trigger: 'blur' }
                    ],
                    channeler_id: [
                        { required: true, message: '请选择渠道人员', trigger: ['blur','change'] }
                    ],
                },
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    channel_id: '',
                    channel_name: '',
                    channeler_id: '',
                    channeler_name: '',
                    channel_company: '',
                    orderby: ''
                },
                listData: [], //渠道数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                channellist:[],
                channelerlist:[], //渠道人员列表
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            this.reset()
            this.getchannellist();
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取渠道列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                channelList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道人员列表
            getchannellist() {
                var that = this;
                that.channelerlist = [];
                var data = {
                    'pagesize': '0',
                    'role_name': '渠道'
                }
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelerlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道信息
            getchannelInfo(id) {
                var that = this;
                channelInfo({ channel_id: id }).then(res => {
                    if (res.statusCode == 200) {
                        that.channelerlist.forEach(item => {
                            if(item.id == res.data.channeler_id){
                                res.data.channeler_name = item.value
                            }
                        });
                        that.editForm = res.data;
                    } else {
                        that.$message.error(res.message)
                    }
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('channe', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('channe', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    channel_id: '',
                    channel_name: '',
                    channeler_id: '',
                    channeler_name: '',
                    channel_company: '',
                    orderby: ''
                }
                // 重置清掉本地搜索缓存
                localStorage.removeItem('channe')
                this.channellist = channelListTotal()
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    this.title = '修改渠道'
                    this.getchannelInfo(row.channel_id);
                } else {
                    this.title = '添加渠道'
                    this.editForm = {
                        channel_id: '',
                        channel_name: '',
                        channeler_id: '',
                        channeler_name: '',
                        channel_company: '',
                        remark: '',
                    }
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                var that = this;
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        var editForm = that.editForm
                        // 添加没有channel_id
                        if (!editForm.channel_id) {
                            delete editForm.channel_id
                        }
                        delete editForm.channeler_name
                        channelSave(editForm)
                            .then(res => {
                                that.editFormVisible = false
                                if (res.statusCode == 200) {
                                    // 添加渠道时清空搜索条件
                                    if (that.title == '添加渠道') {
                                        that.reset();
                                    } else {
                                        that.getdata(that.formInline)
                                    }
                                    that.$message({
                                        type: 'success',
                                        message: that.title + '成功！'
                                    })
                                } else {
                                    that.$message.error(res.message)
                                }
                            })
                    } else {
                        return false
                    }
                })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
            // 接口配置
            handleDispose() {

            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var channellist = this.channellist;
                var results = queryString ? channellist.filter(this.createFilter(queryString)) : channellist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var channelerlist = this.channelerlist;
                var results = queryString ? channelerlist.filter(this.createFilter(queryString)) : channelerlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.channel_id = item.id;
                    this.formInline.channel_name = item.value;
                }else if(index == 2){
                    this.formInline.channeler_id = item.id;
                    this.formInline.channeler_name = item.value;
                }else if(index == 3){
                    this.editForm.channeler_id = item.id;
                    this.editForm.channeler_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.channel_id = '';
                    this.formInline.channel_name = '';
                    localStorage.setItem('channe', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.channeler_id = '';
                    this.formInline.channeler_name = '';
                    localStorage.setItem('channe', JSON.stringify(this.formInline))
                }
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .page-box {
        text-align: right !important;
    }

    /* 固定el-table头部 */
    .el-table {
        max-height: calc(100vh - 380px) !important;
    }

    .el-table__body-wrapper.is-scrolling-none {
        overflow-y: auto !important;
        max-height: calc(100vh - 465px) !important;
    }

    .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/control/channellist.vue